import { render, staticRenderFns } from "./statisticalDetails.vue?vue&type=template&id=5e1538c4&scoped=true"
import script from "./statisticalDetails.vue?vue&type=script&lang=js"
export * from "./statisticalDetails.vue?vue&type=script&lang=js"
import style0 from "./statisticalDetails.vue?vue&type=style&index=0&id=5e1538c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1538c4",
  null
  
)

export default component.exports